module.exports = __webpack_public_path__ + "static/img/women_04.c51c447.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c15/women_04.jpg
// module id = Nbv8
// module chunks = 0